import * as React from "react";

function SvgAngleRight(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 478.448 478.448" {...props}>
      <path d="M131.659 0l-31.165 32.035 213.31 207.197-213.31 207.141 31.156 32.075 246.304-239.216z" />
    </svg>
  );
}

export default SvgAngleRight;
